import Competition from "model/Competition";
import {fetchApiClient} from "common/fetchApiClient";
import {API_URL} from "common/const";
import { AxiosError } from "axios";
import UnauthorizedError from "api/errors/UnauthorizedError";


const recalculatePoints = async (competition: Competition, token: string | undefined): Promise<void> => {
    const apiClient = fetchApiClient(token);

    await apiClient.post(`${API_URL}/points/${competition.code}`)
    .catch((error: AxiosError) => {
        console.log(`Error recalculating points for Competition(${competition.code})`, error);
        if (!!error.response && error.response.status === 403) {
            throw new UnauthorizedError();
        }
        throw error;
    });
}

export default recalculatePoints;
